<template>
  <b-modal
      ref="show-security-group-modal"
      :title="$t('groups.show_group_details.title')"
      ok-only
      size="lg"
  >
    <div v-if="isLoading" class="d-flex justify-content-center m-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{$t('state.loading')}}</span>
      </div>
    </div>
    <div v-if="!isLoading" class="question-details">
      <h4>{{ $t('groups.show_group_details.basic_data') }}</h4>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $t('groups.show_group_details.group_id') }}:</th>
              <td>{{ group.id }}</td>
            </tr>
            <tr>
              <th>{{ $t('groups.show_group_details.group_name') }}:</th>
              <td>{{ group.name }}</td>
            </tr>
            <tr>
              <th>{{ $t('groups.show_group_details.group_key') }}:</th>
              <td>{{ group.key }}</td>
            </tr>
            <tr>
              <th>{{ $t('groups.show_group_details.group_roles_count') }}:</th>
              <td>{{ group.rolesCount }}</td>
            </tr>
            <tr>
              <th>{{ $t('groups.show_group_details.group_created_at') }}:</th>
              <td>{{ groupCreatedAt }}</td>
            </tr>
            <tr>
              <th>{{ $t('groups.show_group_details.group_updated_at') }}:</th>
              <td>{{ groupUpdatedAt }}</td>
            </tr>
          </table>
        </div>
      </div>
      <h4>{{ $t('groups.show_group_details.roles') }}</h4>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr v-for="role in roles" :key="role.role">
              <td class="text-success text-bold">{{ role.role }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
      isLoading: true,
      group: null,
      groupCreatedAt: null,
      groupUpdatedAt: null,
      roles: null
    }
  },
  methods: {
    openModal(group) {
      this.resetProperties();
      this.getQuestionDetails(group);
      this.$refs['show-security-group-modal'].show();
    },
    getQuestionDetails(group) {
      this.group = group;
      this.groupCreatedAt = moment(group).format('YYYY-MM-DD, h:mm:ss a');
      this.groupUpdatedAt = moment(group).format('YYYY-MM-DD, h:mm:ss a');

      axios.get(`/api/group/role/${group.id}`)
        .then(resp => {
          this.roles = resp.data.items.results;
          this.isLoading = false;
        });
    },
    resetProperties() {
      this.isLoading = true;
      this.group = null;
      this.groupCreatedAt = null;
      this.groupUpdatedAt = null;
      this.roles = null;
    }
  }
}
</script>
